module.exports = __webpack_public_path__ + "static/media/Zelt2.8a56a81d.png";